import cx from 'clsx';
import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

import useTranslation from '@hooks/useTranslation';

import type { IAssetInstallationPoint } from '@pages/Sensors/model/assetEquipment';

import { getPointStatusType } from '../../helpers/getPointStatusType';
import { useSensorViewedStoreActions } from '../../store/useSensorViewedStore';
import style from './style.module.scss';

interface IProps {
  point: IAssetInstallationPoint;
  equipmentName: string;
  equipmentId: number;
}

const InstallationPointItem: React.FC<IProps> = ({ point, equipmentName = '', equipmentId }) => {
  const { t } = useTranslation();
  const { customerId } = useParams();
  const { pathname } = useLocation();

  const { setLastViewedSensorId } = useSensorViewedStoreActions();

  const pointStatusType = getPointStatusType(point);

  return (
    <Link
      title={`${t('Primary asset')}: ${equipmentName}, ${point.name}`}
      to={`/customer/${customerId}/equipment-details/sensor/${point.id}`}
      state={{ prevPage: pathname }}
      onClick={() => setLastViewedSensorId(equipmentId)}
    >
      <div className={cx(style.pointItem, style[pointStatusType], { [style.snoozed]: point.snoozed })} />
    </Link>
  );
};

export default InstallationPointItem;
